import * as React from 'react';

import AuthenticationModal from 'bundles/authentication/shared/components/authentication-modal/AuthenticationModal';

class OndemandLoggedOutRedirector extends React.Component {
  render() {
    return <AuthenticationModal defaultMode="login" />;
  }
}

export default OndemandLoggedOutRedirector;
